var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { StructuredPageData } from '../StructuredData';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
const ContentRoute = function ContentRoute(props) {
    var _a, _b, _c, _d;
    const { result, component: ContentPage } = props, rest = __rest(props, ["result", "component"]);
    const page = (_c = (_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.route) === null || _b === void 0 ? void 0 : _b.object) !== null && _c !== void 0 ? _c : (_d = result.data) === null || _d === void 0 ? void 0 : _d.page;
    const { structuredData } = useShopConfig();
    const disableDefaultPageData = structuredData
        ? !!structuredData.disableDefaultPageData
        : false;
    return (React.createElement(React.Fragment, null,
        page && !disableDefaultPageData && React.createElement(StructuredPageData, { page: page }),
        React.createElement(ContentPage, Object.assign({ result: result, page: page }, rest))));
};
export default ContentRoute;
//# sourceMappingURL=ContentRoute.js.map